var _0x2f98 = [
  window.location.hostname,
  Shopify.shop,
  "\x68\x72\x65\x66",
  "\x6C\x6F\x63\x61\x74\x69\x6F\x6E",
  "\x69\x6E\x64\x65\x78\x4F\x66",
  "\x73\x68\x6F\x70\x69\x66\x79\x70\x72\x65\x76\x69\x65\x77\x2E\x63\x6F\x6D",
  "\x73\x68\x6F\x70\x69\x66\x79\x2E\x63\x6F\x6D",
  "\x55\x6E\x61\x75\x74\x68\x6F\x72\x69\x73\x65\x64\x20\x75\x73\x65\x20\x6F\x66\x20\x63\x6F\x64\x65\x20\x64\x65\x74\x65\x63\x74\x65\x64\x2E\x20\x75\x73\x69\x6E\x67\x20\x74\x68\x65\x20\x63\x6F\x70\x79\x72\x69\x67\x68\x74\x65\x64\x20\x63\x6F\x64\x65\x20\x77\x69\x74\x68\x6F\x75\x74\x20\x70\x72\x69\x6F\x72\x20\x70\x65\x72\x6D\x69\x73\x73\x69\x6F\x6E\x2E",
  "\x6C\x6F\x67",
  "\x73\x63\x72\x69\x70\x74",
  "\x67\x65\x74\x45\x6C\x65\x6D\x65\x6E\x74\x73\x42\x79\x54\x61\x67\x4E\x61\x6D\x65",
  "\x6C\x65\x6E\x67\x74\x68",
  "\x64\x61\x74\x61\x2D\x73\x72\x63",
  "\x67\x65\x74\x41\x74\x74\x72\x69\x62\x75\x74\x65",
  "\x73\x72\x63",
  "\x73\x65\x74\x41\x74\x74\x72\x69\x62\x75\x74\x65",
  "\x64\x61\x74\x61\x73\x65\x74",
  "\x74\x79\x70\x65",
  "\x74\x65\x78\x74\x2F\x6A\x61\x76\x61\x73\x63\x72\x69\x70\x74\x73",
  "\x63\x72\x65\x61\x74\x65\x45\x6C\x65\x6D\x65\x6E\x74",
  "\x61\x74\x74\x72\x69\x62\x75\x74\x65\x73",
  "\x6E\x61\x6D\x65",
  "\x76\x61\x6C\x75\x65",
  "\x74\x65\x78\x74\x2F\x6A\x61\x76\x61\x73\x63\x72\x69\x70\x74",
  "\x69\x6E\x6E\x65\x72\x48\x54\x4D\x4C",
  "\x72\x65\x6D\x6F\x76\x65\x43\x68\x69\x6C\x64",
  "\x70\x61\x72\x65\x6E\x74\x4E\x6F\x64\x65",
  "\x69\x6E\x73\x65\x72\x74\x42\x65\x66\x6F\x72\x65",
  "\x53\x74\x61\x72\x74\x41\x73\x79\x6E\x63\x4C\x6F\x61\x64\x69\x6E\x67",
  "\x64\x69\x73\x70\x61\x74\x63\x68\x45\x76\x65\x6E\x74",
  "\x73\x74\x61\x72\x74\x61\x73\x79\x6E\x63\x6C\x6F\x61\x64\x69\x6E\x67",
  "\x73\x63\x72\x6F\x6C\x6C",
  "\x61\x64\x64\x45\x76\x65\x6E\x74\x4C\x69\x73\x74\x65\x6E\x65\x72",
  "\x6D\x6F\x75\x73\x65\x6D\x6F\x76\x65",
  "\x74\x6F\x75\x63\x68\x73\x74\x61\x72\x74",
  "\x6C\x6F\x61\x64",
  "\x61\x74\x74\x61\x63\x68\x45\x76\x65\x6E\x74",
  "\x6F\x6E\x6C\x6F\x61\x64",
];
var domain_url = _0x2f98[0];
var domain_admin_url = _0x2f98[1];
var current_url = window[_0x2f98[3]][_0x2f98[2]];
if (
  current_url[_0x2f98[4]](domain_url) < 0 &&
  current_url[_0x2f98[4]](domain_admin_url) < 0 &&
  current_url[_0x2f98[4]](_0x2f98[5]) < 0 &&
  current_url[_0x2f98[4]](_0x2f98[6])
) {
  console[_0x2f98[8]](_0x2f98[7]);
} else {
  var script_loaded = false;
  function loadAsync() {
    if (script_loaded) {
      return;
    } else {
      script_loaded = true;
      
      // Load color-media-filter.js first
      loadColorFilterScript(function() {
        // After color filter is loaded, load the rest of the scripts
        loadRemainingScripts();
      });
    }
  }
  
  // Function to load color-media-filter.js first
  function loadColorFilterScript(callback) {
    var colorFilterScript = document.querySelector('script[src*="color-media-filter.js"]');
    
    if (colorFilterScript) {
      // If the script already exists, set its src attribute
      if (colorFilterScript.getAttribute(_0x2f98[12]) !== null) {
        colorFilterScript[_0x2f98[15]](
          _0x2f98[14],
          colorFilterScript[_0x2f98[13]](_0x2f98[12])
        );
        delete colorFilterScript[_0x2f98[16]][_0x2f98[14]];
      }
      
      // After color filter script loads, proceed to load remaining scripts
      colorFilterScript.onload = function() {
        console.log("Color media filter script loaded");
        document.dispatchEvent(new CustomEvent('color-filter:loaded'));
        if (callback) callback();
      };
    } else {
      // If no color filter script found, proceed to load other scripts
      console.log("No color-media-filter.js found");
      if (callback) callback();
    }
  }
  
  // Function to load the remaining scripts, now loads bridge at the end
  function loadRemainingScripts() {
    var _0x9bfax6 = document[_0x2f98[10]](_0x2f98[9]);
    var scripts = [];
    var bridgeScript = null;
    
    // Process all scripts except bridge script
    for (var _0x9bfax7 = 0; _0x9bfax7 < _0x9bfax6[_0x2f98[11]]; _0x9bfax7++) {
      // Skip color-media-filter.js as it was already handled
      if (_0x9bfax6[_0x9bfax7].src && _0x9bfax6[_0x9bfax7].src.indexOf('color-media-filter.js') !== -1) {
        continue;
      }
      
      // Skip bridge script for now, process it last
      if (_0x9bfax6[_0x9bfax7].src && _0x9bfax6[_0x9bfax7].src.indexOf('color-filter-bridge.js') !== -1) {
        bridgeScript = _0x9bfax6[_0x9bfax7];
        continue;
      }
      
      scripts.push(_0x9bfax6[_0x9bfax7]);
    }
    
    // Process all other scripts first
    scripts.forEach(function(script) {
      if (script[_0x2f98[13]](_0x2f98[12]) !== null) {
        script[_0x2f98[15]](
          _0x2f98[14],
          script[_0x2f98[13]](_0x2f98[12])
        );
        delete script[_0x2f98[16]][_0x2f98[14]];
      }
      if (script[_0x2f98[13]](_0x2f98[17]) == _0x2f98[18]) {
        var _0x9bfax8 = document[_0x2f98[19]](_0x2f98[9]);
        for (
          var _0x9bfax9 = 0;
          _0x9bfax9 < script[_0x2f98[20]][_0x2f98[11]];
          _0x9bfax9++
        ) {
          var _0x9bfaxa = script[_0x2f98[20]][_0x9bfax9];
          _0x9bfax8[_0x2f98[15]](
            _0x9bfaxa[_0x2f98[21]],
            _0x9bfaxa[_0x2f98[22]]
          );
        }
        _0x9bfax8[_0x2f98[17]] = _0x2f98[23];
        _0x9bfax8[_0x2f98[24]] = script[_0x2f98[24]];
        script[_0x2f98[26]][_0x2f98[25]](script);
        script[_0x2f98[26]][_0x2f98[27]](
          _0x9bfax8,
          script
        );
      }
    });
    
    // Now process bridge script last
    if (bridgeScript) {
      if (bridgeScript[_0x2f98[13]](_0x2f98[12]) !== null) {
        bridgeScript[_0x2f98[15]](
          _0x2f98[14],
          bridgeScript[_0x2f98[13]](_0x2f98[12])
        );
        delete bridgeScript[_0x2f98[16]][_0x2f98[14]];
      }
      if (bridgeScript[_0x2f98[13]](_0x2f98[17]) == _0x2f98[18]) {
        var _0x9bfax8 = document[_0x2f98[19]](_0x2f98[9]);
        for (
          var _0x9bfax9 = 0;
          _0x9bfax9 < bridgeScript[_0x2f98[20]][_0x2f98[11]];
          _0x9bfax9++
        ) {
          var _0x9bfaxa = bridgeScript[_0x2f98[20]][_0x9bfax9];
          _0x9bfax8[_0x2f98[15]](
            _0x9bfaxa[_0x2f98[21]],
            _0x9bfaxa[_0x2f98[22]]
          );
        }
        _0x9bfax8[_0x2f98[17]] = _0x2f98[23];
        _0x9bfax8[_0x2f98[24]] = bridgeScript[_0x2f98[24]];
        bridgeScript[_0x2f98[26]][_0x2f98[25]](bridgeScript);
        bridgeScript[_0x2f98[26]][_0x2f98[27]](
          _0x9bfax8,
          bridgeScript
        );
      }
      console.log("Color filter bridge script loaded last");
      document.dispatchEvent(new CustomEvent('color-filter-bridge:loaded'));
    }
    
    setTimeout(function () {
      document[_0x2f98[29]](new CustomEvent(_0x2f98[28]));
    }, 900);
    document[_0x2f98[29]](new CustomEvent(_0x2f98[30]));
  }
  
  // Listen for color-filter events in PhotoSwipe and theme.js
  document.addEventListener('color-filter:before-filter', function(e) {
    // Notify PhotoSwipe and theme.js that filtering is about to happen
    console.log('Color filtering starting for color:', e.detail);
  });
  
  document.addEventListener('color-filter:after-filter', function(e) {
    // Notify PhotoSwipe and theme.js that filtering is complete
    console.log('Color filtering complete for color:', e.detail[0], 'with', e.detail[1], 'matches');
    
    // Refresh PhotoSwipe if it exists
    if (window.PhotoSwipe) {
      console.log('Notifying PhotoSwipe of filter changes');
    }
    
    // Refresh slick sliders if they exist
    if (jQuery && jQuery.fn.slick) {
      console.log('Refreshing slick sliders after color filtering');
      jQuery('.slick-initialized').slick('refresh');
      
      // Go to first slide that's not filtered
      jQuery('.slick-initialized').each(function() {
        var firstVisibleSlide = jQuery(this).find('.slick-slide:not(.color-filtered)').first();
        if (firstVisibleSlide.length) {
          var slideIndex = firstVisibleSlide.data('slick-index') || 0;
          jQuery(this).slick('slickGoTo', slideIndex, true);
        }
      });
    }
  });
  
  window[_0x2f98[32]](_0x2f98[31], function (_0x9bfaxb) {
    loadAsync();
  });
  window[_0x2f98[32]](_0x2f98[33], function () {
    loadAsync();
  });
  window[_0x2f98[32]](_0x2f98[34], function () {
    loadAsync();
  });
  if (window[_0x2f98[32]]) {
    window[_0x2f98[32]](
      _0x2f98[35],
      function () {
        setTimeout(loadAsync, 9000);
      },
      false
    );
  } else {
    if (window[_0x2f98[36]]) {
      window[_0x2f98[36]](_0x2f98[37], function () {
        setTimeout(loadAsync, 9000);
      });
    } else {
      window[_0x2f98[37]] = loadAsync;
    }
  }
}
